/** Human-readable labels for permission matrix rows (Zoho-style). */

export const MATRIX_COLUMNS = [
  { key: "full_control", label: "Full access" },
  { key: "view", label: "View" },
  { key: "create", label: "Create" },
  { key: "edit", label: "Edit" },
  { key: "approve", label: "Approve" },
];

export const MODULE_LABELS = {
  employees: "Employee",
  payroll: "Payroll",
  attendance: "Attendance",
  leave: "Leave",
  recruitment: "Recruitment",
  finance: "Finance",
  compliance: "Compliance",
  settings: "Settings",
};

const RESOURCE_LABELS = {
  employee_profile: "Basic details",
  employee_documents: "Employee documents",
  employee_salary: "Salary details",
  employee_bank_details: "Payment information",
  employee_tax: "Tax & declarations",
  employee_attendance: "Attendance",
  employee_leave: "Leave",
  employee_assets: "Assets",
  employee_performance: "Performance",
  employee_separation: "Separation",
  employee_notes: "Notes",
  employee_history: "History",
  pay_runs: "Pay runs",
  salary_structures: "Salary structures",
  salary_components: "Salary components",
  payslips: "Payslips",
  payroll_approvals: "Payroll approvals",
  leave_requests: "Leave requests",
  leave_approvals: "Leave approvals",
  expense_claims: "Expense claims",
  expense_approvals: "Expense approvals",
  users: "Users",
  roles: "Roles",
  permissions: "Permissions",
};

export function resourceLabel(key) {
  return RESOURCE_LABELS[key] || key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function normalizeResourcePerms(value) {
  if (!value) return {};
  if (typeof value === "string") {
    if (value === "full_control" || value === "manage") {
      return { full_control: true, view: true, create: true, edit: true, approve: true };
    }
    return { [value]: true };
  }
  if (typeof value === "object") return { ...value };
  return {};
}

export function emptyMatrixFromCatalog(catalog) {
  const matrix = {};
  const modules = catalog?.modules || {};
  Object.entries(modules).forEach(([mod, resources]) => {
    matrix[mod] = {};
    resources.forEach((res) => {
      matrix[mod][res] = {};
    });
  });
  return matrix;
}
